import React from "react";
import "./BenevvSubmitField.css";

interface BenevvSubmitFieldProps
  extends React.HTMLAttributes<HTMLInputElement> {
  className?: string;
  value: string;
}

function BenevvSubmitField(props: BenevvSubmitFieldProps) {
  const { value, className, ...rest } = props;
  return (
    <input
      type={"submit"}
      value={value}
      className={`benevv-submit-field ${className}`}
      {...rest}
    />
  );
}

export default BenevvSubmitField;
